<template>
	<div v-if="single" :id="attributeName + '__area'">
		<div data-attribute-type="single" :class="getColumnClass()" data-attribute-index="0">
			<div :class="SINGLE_ATTRIBUTE">
				<div class="col-sm-5">
					<AttributeLabel
						:attributeName="attributeName"
						:localizedTitle="localizedTitle"
						:is-primary="isPrimary"
						:is-multiple="isMultiple"
						:max-count="maxCount"
						:sl-attribute="false"
						:locked-edit="lockedEdit"
						:enable-copy-attribute-name="enableCopyAttributeName"
					/>
				</div>
				<div class="col-sm-7">
					<select :id="'list__' + attributeName"
							:class="'select attribute-editor ' + getDefaultValueWithLockClasses()"
							:value="attributeValue"
							:disabled="lockedEdit">
						<option v-for="(value, key) in options" :value="key">{{ $t(value) || value }}</option>
					</select>
				</div>
			</div>
		</div>
	</div>
	<div v-else>
		<div data-attribute-type="single" :class="getColumnClass()" data-attribute-index="0">
			<div :class="SINGLE_ATTRIBUTE" v-for="(val, key) in attributeValue" :key="key">
				<select :id="'list__' + attributeName + '__' + key"
						:class="'select attribute-editor multiple-hotkey ' + getDefaultValueWithLockClasses()"
						:value="val"
						:disabled="lockedEdit">
					<option v-for="(value, key) in options" :value="key">{{ $t(value) || value }}</option>
				</select>
				<button v-if="!lockedEdit" class="button_minus fa fa-minus" tabindex="-1"></button>
			</div>
		</div>
	</div>
</template>

<script>
import AttributeLabel from './AttributeLabel'
import defaultClassManager from '../../mixins/defaultClassManager'

export default {
	components: {
		AttributeLabel,
	},
	mixins: [defaultClassManager],
	name: 'LAttributeEditorComponent',
	props: [
		'attributeName',
		'localizedTitle',
		'isMultiple',
		'isPrimary',
		'maxLength',
		'maxCount',
		'defaultValue',
		'defaultLock',
		'localization',
		'colspan',
		'classificators',
		'classificatorType',
		'enableCopyAttributeName',
		'itemData',
		'lockedEdit'
	],
	data () {
		return {
			single: !this.isMultiple,
			options: this.classificators[this.classificatorType],
			SINGLE_ATTRIBUTE: 'single-attribute'
		}
	},
	computed: {
		attributeValue: function () {
			if (this.itemData) {
				return this.itemData
			} else if (this.defaultValue) {
				return this.defaultValue
			} else {
				return !this.isMultiple ? '' : []
			}
		}
	}
}
</script>

<style scoped>

</style>
